import React, { useEffect, useState } from 'react';
import { userInventory } from '../../../apis/user';
import ProductSkeleton from '../../Product/Skeleton';
import BoxEmpty from '../../../components/Empty';
import { Grid } from '@mui/material';
import PurchasesCard from '../../../components/Card/PurchasesCard';
import UsersUsedProduct from '../../../components/Product/UsersUsedProduct';
import TestAssignmentDialog from '../../../components/UserManagement/TestAssignment';
import TransfersProduct from '../../../components/Product/Transfers';

const PurchasesExams = () => {
  const [loading, setLoading] = useState(true);
  const [purchasesExamList, setPurchasesExamList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openUsersUsedProduct, setOpenUsersUsedProduct] = useState(false);
  const [openTestAssignmentDialog, setOpenTestAssignmentDialog] = useState(false);
  const [openTransfersProduct, setOpenTransfersProduct] = useState(false);
  const [transferCode, setTransferCode] = useState(null);

  const getPurchasesExamsData = () => {
    setLoading(true);
    userInventory()
      .then((res) => setPurchasesExamList(res?.data || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getPurchasesExamsData();
  }, []);

  if (loading) return <ProductSkeleton />;

  if (purchasesExamList.length === 0) return <BoxEmpty />;

  return (
    <Grid container mt={2} spacing={3}>
      {purchasesExamList.map((item) => (
        <Grid item lg={4} md={6} xs={12} key={item.productId}>
          <PurchasesCard
            product={item}
            setOpenTransfersProduct={setOpenTransfersProduct}
            setOpenTestAssignmentDialog={setOpenTestAssignmentDialog}
            setSelectedProduct={setSelectedProduct}
          />
        </Grid>
      ))}

      <TransfersProduct
        openTransfersProduct={openTransfersProduct}
        closeDialog={() => setOpenTransfersProduct(false)}
        setTransferCode={setTransferCode}
        setOpenUsersUsedProduct={setOpenUsersUsedProduct}
      />

      <UsersUsedProduct
        openUsersUsedProduct={openUsersUsedProduct}
        closeDialog={() => setOpenUsersUsedProduct(false)}
        transferCode={transferCode}
        haseInventory
      />

      <TestAssignmentDialog
        openTestAssignmentDialog={openTestAssignmentDialog}
        closeDialog={() => setOpenTestAssignmentDialog(false)}
        selectedProduct={selectedProduct}
        onUpdate={getPurchasesExamsData}
      />
    </Grid>
  );
};

export default PurchasesExams;
